import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// קומפוננטה פנימית קטנה עבור מודל ה"אודות"
function AboutModal({ isOpen, onClose, siteName }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50 p-4" onClick={onClose}>
            <div className="bg-gray-800 text-white rounded-xl p-8 shadow-2xl max-w-sm w-full text-center" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-xl font-bold text-amber-400 mb-2">{siteName || "הצ'ולנטיה"}</h3>
                <p className="text-lg text-gray-300">גרסה 25</p>
                <button 
                    onClick={onClose} 
                    className="mt-6 bg-amber-500 hover:bg-amber-600 text-black font-bold py-2 px-6 rounded-lg transition-colors duration-150"
                >
                    סגור
                </button>
            </div>
        </div>
    );
}

export default function Navbar({ onLogout, isEditMode, setIsEditMode, siteName }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isAboutOpen, setIsAboutOpen] = useState(false);
    const navigate = useNavigate();
    const menuRef = useRef(null);

    // סוגר את התפריט אם לוחצים מחוצה לו
    useEffect(() => {
        function handleClickOutside(event) {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuRef]);

    const handleNavigate = (path, state) => {
        navigate(path, { state });
        setIsOpen(false);
    };

    const handleAbout = () => {
        setIsAboutOpen(true);
        setIsOpen(false);
    };
    
    const handleLogoutClick = () => {
        onLogout();
        setIsOpen(false);
    }

    return (
        <>
            <nav className="bg-gray-800 text-white shadow-lg sticky top-0 z-50" ref={menuRef}>
                <div className="max-w-4xl mx-auto px-4">
                    <div className="flex justify-between items-center h-16">
                        <div className="font-bold text-xl text-amber-400">
                            {siteName || "הצ'ולנטיה"}
                        </div>
                        <div className="flex items-center gap-2 relative">
                            <button
                                onClick={() => setIsEditMode((prev) => !prev)}
                                className="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white hover:bg-gray-700 transition-colors"
                                title={isEditMode ? "מצב עריכה" : "מצב צפייה"}
                            >
                                {isEditMode ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536M9 13l6.586-6.586a2 2 0 112.828 2.828L11.828 15.828a2 2 0 01-2.828 0L9 13zm-6 6h12" />
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm-9 0c0-3.866 3.582-7 8-7s8 3.134 8 7-3.582 7-8 7-8-3.134-8-7z" />
                                    </svg>
                                )}
                            </button>
                            <button onClick={() => setIsOpen(!isOpen)} className="p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                                <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                    {isOpen ? (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                    ) : (
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                    )}
                                </svg>
                            </button>
                            {isOpen && (
                                <div className="origin-top-right absolute left-0 top-full mt-2 w-56 rounded-md shadow-lg bg-gray-700 ring-1 ring-black ring-opacity-5 z-50">
                                    <button onClick={() => handleNavigate('/')} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">בית</button>
                                    <button onClick={() => handleNavigate('/admin', { state: { openSettingsModal: true } })} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">הזמנות פעילות</button>
                                <button onClick={() => handleNavigate('/driver')} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">לוח הזמנות פעילות</button>
                                    <button onClick={() => handleNavigate('/history')} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">היסטוריית הזמנות</button>
                                    <div className="border-t border-gray-600 my-1"></div>
                                    <div className="py-1 text-right" role="menu" aria-orientation="vertical">
                                        <button onClick={() => handleNavigate('/settings')} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">הגדרות</button>
                                        <button onClick={() => handleNavigate('/config')} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">קונפיגורציה</button>
                                        <button onClick={handleAbout} className="block w-full text-right px-4 py-2 text-sm text-gray-200 hover:bg-gray-600">אודות</button>
                                        <button onClick={handleLogoutClick} className="block w-full text-right px-4 py-2 text-sm text-red-400 hover:bg-gray-600">יציאה מהחשבון</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
            <AboutModal isOpen={isAboutOpen} onClose={() => setIsAboutOpen(false)} siteName={siteName} />
        </>
    );
}